import { PSTFieldNames } from '@common/data-models/fields/pst-field-names';
import { IDeepCopy } from '@common/interfaces/i-deep-copy';
import { Util } from '@common/utils/util';

export class ViewStateOptions implements IDeepCopy<ViewStateOptions> {
    public Default: any;
    public Label: string;

    private value: any;
    public set Value(value: any) {
        if (value !== this.value) {
            const prev = this.value;
            this.value = value;
            const current = this._Options.filter(o => o.id === this.value);
            if (current && current.length > 0) {
                this.Label = current[0].title;
            }

            if (this.OnChange) this.OnChange(value, prev);
        }
    }
    public get Value(): any {
        return this.value;
    }

    private _Options: Array<{ id: any; title: string }> = [];
    public get Options(): Array<{ id: any; title: string }> {
        if (this.value !== PSTFieldNames.PSTTopicOrder) {
            return this._Options.filter((item: { id: any; title: string }) => {
                if (item.id !== PSTFieldNames.PSTTopicOrder) return true;
                return false;
            });
        }
        return this._Options;
    }
    public set Options(options: Array<{ id: any; title: string }>) {
        this._Options = options;
    }

    public get AllOptions() {
        return this._Options;
    }

    public Add(option: { id: any; title: string }) {
        this._Options.push(option);
    }

    public OnChange: (value: any, prev: any) => any;

    constructor() {}

    public reset() {
        this.Value = this.Default;
    }

    public toJSON() {
        return this.Value;
    }

    public initialize(value?: any) {
        this.Value = value || this.Default;
    }

    public deepCopy(): ViewStateOptions {
        const ret = new ViewStateOptions();
        ret.Value = this.Value;
        ret.Options = Util.deepCopy(this._Options);
        ret.Default = Util.deepCopy(this.Default);
        ret.Label = this.Label;
        return ret;
    }
}
